import {
  createContact,
  fetchContacts,
  updateContact,
  deleteContact,
  fetchContactsBulk,
} from "@/api/contactService";

export default {
  //Create contact
  async createContact({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.createContactBtn.load = true;
      rootState.loading.createContactBtn.disabled = true;
      await createContact(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Contact created!",
          color: "success",
        },
        { root: true }
      );
      dispatch("fetchContacts", 1);
      rootState.loading.createContactBtn.load = false;
      rootState.loading.createContactBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.createContactBtn.load = false;
      rootState.loading.createContactBtn.disabled = false;
    }
  },

  //Fetch contacts
  async fetchContacts({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchContacts(pageNumber);
      const contacts = response.data.data;
      commit("SET_CONTACT_DATA", contacts);
      commit("SET_CONTACT_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your contacts arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Update contact
  async updateContact({ commit, rootState, dispatch, state }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.contactUpdateBtn.load = true;
      rootState.loading.contactUpdateBtn.disabled = true;
      await updateContact(payload);
      const pageNumber = state.contacts.currentPage;
      dispatch("fetchContacts", pageNumber);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Contact updated!",
          color: "success",
        },
        { root: true }
      );
      rootState.loading.contactUpdateBtn.load = false;
      rootState.loading.contactUpdateBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.contactUpdateBtn.load = false;
      rootState.loading.contactUpdateBtn.disabled = false;
    }
  },

  //Delete contact
  async deleteContact(context, payload) {
    context.commit("SHOW_PROGRESSBAR", true, { root: true });
    await deleteContact(payload);
    const pageNumber = context.state.contacts.currentPage;
    context.dispatch("fetchContacts", pageNumber);
    context.commit("HIDE_PROGRESSBAR", false, { root: true });
    context.commit(
      "SHOW_SNACKBAR",
      {
        text: "Contact deleted!",
        color: "success",
      },
      { root: true }
    );
  },

  //Fetch contacts bulk
  async fetchContactsBulk({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchContactsBulk(pageNumber);
      const contacts = response.data.data;
      commit("SET_CONTACT_DATA", contacts);
      commit("SET_CONTACT_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your contacts arrived.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },
};
